import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar directamente los objetos de traducción
const translationES = {
    "navbar": {
        "home": "Inicio",
        "projects": "Proyectos",
        "skills": "Habilidades",
        "experience": "Experiencia",
        "resume": "Currículum",
        "contact": "Contacto",
        "interests": "Intereses"
    },
    "hero": {
        "title": "Starlin Frías",
        "subtitle": "Desarrollador Full Stack & AI Specialist",
        "description": "Ingeniero en Sistemas con experiencia en desarrollo web, aplicaciones móviles, chatbots e Inteligencia Artificial. Especializado en LLMs, Agentes IA, LangChain, RAG y soluciones de IA conversacional. Apasionado por crear soluciones digitales eficientes e innovadoras.",
        "contactMe": "Contáctame"
    },
    "projects": {
        "title": "Mis Proyectos",
        "tabs": {
            "all": "Todos",
            "featured": "Destacados",
            "other": "Otros"
        },
        "viewMore": "Ver {{count}} tecnologías más",
        "viewLess": "Ver menos",
        "privateProject": "Proyecto privado",
        "code": "Código",
        "demo": "Demo (Próximamente)",
        "items": [
            {
                "id": 1,
                "title": "Chatbot CRM con IA - Hytech",
                "description": "Plataforma de chatbot inteligente para CRM desarrollada en Hytech con Streamlit. Permite búsquedas en base de datos MySQL utilizando lenguaje natural mediante LangChain con tools personalizadas para consultas SQL automáticas, transformando solicitudes conversacionales en queries estructuradas. Backend con FastAPI."
            },
            {
                "id": 2,
                "title": "Sistema de Reportes con IA - Hytech",
                "description": "Software de reportes empresariales desarrollado en Hytech con IA para análisis y generación automática de informes. Implementado con Streamlit para interfaces interactivas y FastAPI para servicios backend robustos."
            },
            {
                "id": 3,
                "title": "Blog Web con Java",
                "description": "Blog web desarrollado con Java, JDBC para persistencia en H2, JPA y Hibernate para ORM. Frontend con Bootstrap. Incluye websockets para chat y Ajax para paginación."
            },
            {
                "id": 4,
                "title": "Aplicación Web Móvil",
                "description": "Aplicación web adaptable que utiliza HTML5 con LocalStorage, Geolocator e IndexedDB para capturar información sin conexión a internet y sincronizar cuando haya conectividad."
            },
            {
                "id": 5,
                "title": "Acortador de URLs",
                "description": "Servicio de acortamiento de URLs con APIs REST y SOAP, esquema de seguridad JWT y MongoDB para persistencia. Desplegado con proxy inverso y configuración de DNS personalizado."
            },
            {
                "id": 6,
                "title": "Chatbot para Telegram",
                "description": "Desarrollo de chatbot para Telegram utilizando Aiogram (Python) durante mi trabajo en Click Ping. Integración con APIs externas."
            },
            {
                "id": 7,
                "title": "Sistema de Gestión",
                "description": "Sistema de gestión empresarial con PostgreSQL para almacenamiento de datos. Incluye reportes personalizados y panel de administración."
            },
            {
                "id": 8,
                "title": "Pokedex con Flutter",
                "description": "Aplicación móvil que consume la API de Pokemon para mostrar información detallada sobre diferentes Pokémon, sus estadísticas, evoluciones y habilidades. Implementa búsqueda avanzada, favoritos y comparaciones entre Pokémon."
            },
            {
                "id": 9,
                "title": "App de Préstamos",
                "description": "Aplicación móvil para gestión de préstamos personales. Permite registrar clientes, préstamos, pagos y genera reportes de estado. Incluye autenticación de usuarios y sincronización con la nube."
            }
        ]
    },
    "skills": {
        "title": "Mis Habilidades",
        "categories": {
            "all": "Todas",
            "ai": "IA & ML",
            "languages": "Lenguajes",
            "frontend": "Frontend",
            "backend": "Backend",
            "database": "Bases de Datos",
            "other": "Otras"
        },
        "learning": "Siempre estoy aprendiendo nuevas tecnologías y mejorando mis habilidades. Actualmente estoy profundizando en IA avanzada, fine-tuning de LLMs, arquitecturas de agentes autónomos y soluciones empresariales con RAG."
    },
    "experience": {
        "title": "Experiencia y Educación",
        "sections": {
            "work": "Experiencia Laboral",
            "education": "Educación",
            "achievements": "Logros"
        },
        "workItems": [
            {
                "id": 1,
                "title": "AI Specialist",
                "company": "Hytech",
                "period": "2025 - Presente",
                "description": "Especialista en Inteligencia Artificial desarrollando soluciones empresariales innovadoras. Desarrollo de plataforma de chatbot para CRM que permite búsquedas en base de datos MySQL mediante lenguaje natural, utilizando LangChain con tools personalizadas para consultas SQL automáticas. Creación de software de reportes con IA para análisis y generación automática de informes. Implementación con Streamlit para interfaces interactivas y FastAPI para servicios backend robustos.",
                "technologies": ["Python", "LangChain", "OpenAI", "LLMs", "RAG", "AI Agents", "MySQL", "Streamlit", "FastAPI", "SQL Tools", "Prompt Engineering"]
            },
            {
                "id": 2,
                "title": "Desarrollador Web",
                "company": "Click Ping",
                "period": "2024 - 2025",
                "description": "Desarrollador web con experiencia en Django (Python), creando proyectos como chatbots para Telegram (Aiogram) y WhatsApp (Meta Flow). Participación en el modelado de bases de datos y la configuración del panel de administración de Django.",
                "technologies": ["Python", "Django", "Aiogram", "Meta Flow", "PostgreSQL"]
            }
        ],
        "educationItems": [
            {
                "id": 1,
                "title": "Ingeniería en Sistemas",
                "institution": "Pontificia Universidad Católica Madre y Maestra (PUCMM)",
                "period": "Graduado - 2024",
                "description": "Título obtenido en Ingeniería en Sistemas con formación integral en desarrollo de software, bases de datos, redes, seguridad informática y gestión de proyectos tecnológicos."
            },
            {
                "id": 2,
                "title": "Estudios Secundarios",
                "institution": "Politécnico Ernesto Disla Nuñez",
                "period": "Graduado",
                "description": "Formación en ciencias y tecnología."
            }
        ],
        "achievementItems": [
            {
                "id": 1,
                "title": "Final Latinoamericana ICPC 2022",
                "description": "Participante en la International Collegiate Programming Contest (ICPC), calificando a nivel regional y avanzando a la Final Latinoamericana 2022, compitiendo con países como Cuba, Rusia, entre otros."
            }
        ]
    },
    "resume": {
        "title": "Mi Currículum",
        "download": "Descargar CV",
        "view": "Ver CV en nueva pestaña",
        "openPDF": "Abrir PDF",
        "updatedRegularly": "Este CV se actualiza regularmente con mis habilidades y experiencias más recientes, pero el actual no está actualizado.",
        "qualifications": "Resumen de Cualificaciones",
        "qualificationsList": [
            "Ingeniero en Sistemas graduado de la PUCMM con sólidos conocimientos en desarrollo web, móvil e Inteligencia Artificial.",
            "Especialista en IA con experiencia en LLMs, Agentes IA, LangChain, RAG y desarrollo de soluciones conversacionales.",
            "Experiencia en tecnologías como Python, Java, JavaScript, Django, FastAPI, React, Flutter, Streamlit y frameworks de IA modernos.",
            "Actualmente trabajando como AI Specialist en Hytech, desarrollando plataformas de chatbot inteligente y sistemas de reportes con IA utilizando Streamlit y FastAPI.",
            "Desarrollo de plataforma de chatbot CRM con búsquedas en lenguaje natural conectado a MySQL mediante LangChain y tools personalizadas.",
            "Creación de sistema de reportes empresariales potenciado por IA con interfaces en Streamlit y backend robusto en FastAPI.",
            "Participante en la Final Latinoamericana ICPC 2022, demostrando habilidades avanzadas en resolución de problemas y algoritmos.",
            "Capacidad para modelar bases de datos y trabajar con diferentes sistemas de gestión como PostgreSQL, MongoDB y MySQL."
        ],
        "moreDetails": "Para más detalles sobre mi educación, experiencia laboral y proyectos, por favor descarga o visualiza mi currículum completo o contáctame."
    },
    "credentials": {
        "title": "Títulos y Certificaciones",
        "subtitle": "Credenciales académicas oficiales",
        "clickToView": "Click para ampliar",
        "degree": {
            "title": "Ingeniero en Ciencias de la Computación",
            "institution": "Pontificia Universidad Católica Madre y Maestra (PUCMM)",
            "honor": "Magna Cum Laude",
            "date": "Septiembre 2025"
        },
        "certificate": {
            "title": "Certificación Oficial",
            "institution": "Pontificia Universidad Católica Madre y Maestra (PUCMM)",
            "honor": "Magna Cum Laude",
            "date": "Septiembre 2025"
        }
    },
    "contact": {
        "title": "Contáctame",
        "info": {
            "title": "Información de Contacto",
            "phone": "Teléfono",
            "location": "Ubicación",
            "message": "¿Tienes un proyecto en mente? No dudes en contactarme para discutir cómo puedo ayudarte a hacerlo realidad."
        },
        "form": {
            "title": "Envíame un Mensaje",
            "name": "Nombre",
            "email": "Email",
            "subject": "Asunto",
            "message": "Mensaje",
            "sending": "Enviando...",
            "send": "Enviar Mensaje",
            "success": "¡Gracias por tu mensaje! Me pondré en contacto contigo pronto.",
            "error": "Error al enviar el formulario"
        }
    },
    "footer": {
        "rights": "Todos los derechos reservados.",
        "madeWith": "Hecho con"
    },
    "notFound": {
        "title": "Página No Encontrada",
        "message": "Lo sentimos, la página que estás buscando no existe o ha sido movida.",
        "redirect": "Serás redirigido a la página principal automáticamente...",
        "backToHome": "Volver al inicio"
    },
    "timeline": {
        "title": "Mi Trayectoria",
        "viewMore": "Ver detalles",
        "viewLess": "Ver menos",
        "items": [
            {
                "id": 1,
                "date": "2025 - Presente",
                "title": "AI Specialist en Hytech",
                "description": "Especialista en Inteligencia Artificial desarrollando soluciones empresariales innovadoras. Desarrollo de plataforma de chatbot para CRM con búsquedas en lenguaje natural y sistema de reportes con IA.",
                "type": "work",
                "details": [
                    "Desarrollo de plataforma de chatbot para CRM con búsquedas en base de datos MySQL mediante lenguaje natural",
                    "Implementación con LangChain y tools personalizadas para consultas SQL automáticas",
                    "Creación de software de reportes con IA para análisis y generación automática de informes",
                    "Implementación con Streamlit para interfaces interactivas y FastAPI para servicios backend robustos"
                ]
            },
            {
                "id": 2,
                "date": "2024 - 2025",
                "title": "Desarrollador Web en Click Ping",
                "description": "Desarrollé aplicaciones web utilizando Django (Python), creando proyectos como chatbots para Telegram (Aiogram) y WhatsApp (Meta Flow). Modelado de bases de datos y configuración del panel de administración de Django.",
                "type": "work",
                "details": [
                    "Creación de APIs RESTful para servicios internos y externos",
                    "Implementación de autenticación y autorización usando JWT",
                    "Trabajo con PostgreSQL para gestión de bases de datos",
                    "Colaboración con diseñadores UX/UI para implementación frontend"
                ]
            },
            {
                "id": 3,
                "date": "2023",
                "title": "Competencia Internacional de Programación (ICPC)",
                "description": "Calificado a nivel regional, avanzando a la Final Latinoamericana 2022, compitiendo con países como Cuba, Rusia, entre otros.",
                "type": "achievement",
                "details": [
                    "Resolución de problemas algorítmicos complejos bajo presión de tiempo",
                    "Colaboración con compañeros de equipo para idear soluciones eficientes",
                    "Práctica de estructuras de datos avanzadas y algoritmos",
                    "Desarrollo de habilidades de resolución de problemas en entornos competitivos"
                ]
            },
            {
                "id": 4,
                "date": "2022 - Presente",
                "title": "Proyectos de Desarrollo Full Stack",
                "description": "Desarrollo de varias aplicaciones web, incluyendo una plataforma de blog, acortador de URLs y aplicaciones web móviles.",
                "type": "project",
                "details": [
                    "Creación de un blog web con Java, JDBC, JPA y Hibernate",
                    "Desarrollo de un servicio de acortamiento de URLs con APIs REST y SOAP",
                    "Construcción de aplicaciones web móviles utilizando características de HTML5 como LocalStorage e IndexedDB",
                    "Implementación de autenticación segura y persistencia de datos"
                ]
            },
            {
                "id": 5,
                "date": "2020 - 2024",
                "title": "Graduado de Ingeniería en Sistemas - PUCMM",
                "description": "Graduado en Ingeniería en Sistemas de la Pontificia Universidad Católica Madre y Maestra, con formación en desarrollo de software, bases de datos, redes y gestión de proyectos tecnológicos.",
                "type": "education",
                "details": [
                    "Cursos en algoritmos, estructuras de datos y patrones de diseño",
                    "Gestión de bases de datos y arquitectura de sistemas",
                    "Prácticas y metodologías de ingeniería de software",
                    "Infraestructura de redes y protocolos de seguridad"
                ]
            },
            {
                "id": 6,
                "date": "2019",
                "title": "Educación Secundaria en Politécnico Ernesto Disla Nuñez",
                "description": "Completé educación secundaria con enfoque en ciencias y tecnología.",
                "type": "education",
                "details": [
                    "Graduado con honores",
                    "Participación en competencias de programación y matemáticas",
                    "Desarrollo de comprensión fundamental de principios de computación",
                    "Liderazgo en proyectos tecnológicos estudiantiles"
                ]
            }
        ]
    },
    "hobbies": {
        "title": "Mis Intereses y Pasatiempos",
        "subtitle": "Más allá de la programación, estas son algunas de las actividades que disfruto en mi tiempo libre.",
        "backToPortfolio": "Volver al portafolio",
        "footer": "¿Compartimos algún interés? ¡Cuéntame sobre ello en la sección de contacto!",
        "items": [
            {
                "name": "Ciclismo",
                "description": "Disfruto recorrer nuevas rutas en bicicleta los fines de semana, explorando paisajes naturales y urbanos. Es mi forma favorita de ejercicio y conexión con la naturaleza.",
                "details": [
                    "Rutas favoritas en Santiago",
                    "Participación en eventos ciclistas locales",
                    "Mantenimiento de bicicletas como hobby adicional"
                ]
            },
            {
                "name": "Programación",
                "description": "Más allá del aspecto profesional, disfruto programar proyectos personales y participar en hackathons. Me gusta experimentar con nuevas tecnologías y lenguajes.",
                "details": [
                    "Participación en competencias de programación",
                    "Contribuciones a proyectos open source",
                    "Desarrollo de pequeñas aplicaciones para uso personal"
                ]
            },
            {
                "name": "Escuchar Música",
                "description": "La música es mi compañera constante. Disfruto explorar diferentes géneros y descubrir nuevos artistas. Tengo una colección de playlists para diferentes estados de ánimo y actividades.",
                "details": [
                    "Géneros favoritos: rock alternativo, jazz y música electrónica",
                    "Coleccionista digital de álbumes clásicos",
                    "Asistencia a conciertos locales cuando es posible"
                ]
            },
            {
                "name": "Estudiar",
                "description": "Me apasiona el aprendizaje continuo, no solo en tecnología sino en diversos campos del conocimiento. Dedico tiempo regularmente a cursos online, libros técnicos y artículos científicos.",
                "details": [
                    "Cursos completados en plataformas como Coursera y edX",
                    "Lectura regular de publicaciones técnicas",
                    "Participación en grupos de estudio"
                ]
            },
            {
                "name": "Videojuegos",
                "description": "Los videojuegos son mi forma favorita de relajación. Disfruto especialmente los juegos de estrategia, RPGs y títulos independientes con narrativas innovadoras.",
                "details": [
                    "Juegos favoritos: series Civilization, The Witcher, Hollow Knight",
                    "Interés en el desarrollo indie de videojuegos",
                    "Participación ocasional en game jams"
                ]
            },
            {
                "name": "Senderismo",
                "description": "Descubrir nuevas rutas y conectar con la naturaleza es una de mis actividades favoritas. Me gusta documentar mis caminatas y explorar nuevos senderos en República Dominicana.",
                "details": [
                    "Rutas favoritas en la cordillera Septentrional",
                    "Fotografía de paisajes como hobby complementario",
                    "Planificación de rutas usando tecnología GPS"
                ]
            },
            {
                "name": "Cine",
                "description": "Soy un entusiasta del cine, especialmente de ciencia ficción, documentales tecnológicos y películas independientes. Me gusta analizar narrativas y técnicas cinematográficas.",
                "details": [
                    "Directores favoritos: Christopher Nolan, Denis Villeneuve",
                    "Asistencia regular a festivales de cine locales",
                    "Interés en la intersección entre tecnología y narrativas visuales"
                ]
            }
        ]
    }
};

const translationEN = {
    "navbar": {
        "home": "Home",
        "projects": "Projects",
        "skills": "Skills",
        "experience": "Experience",
        "resume": "Resume",
        "contact": "Contact",
        "interests": "Interests"
    },
    "hero": {
        "title": "Starlin Frías",
        "subtitle": "Full Stack Developer & AI Specialist",
        "description": "Systems Engineer with experience in web development, mobile applications, chatbots, and Artificial Intelligence. Specialized in LLMs, AI Agents, LangChain, RAG, and conversational AI solutions. Passionate about creating efficient and innovative digital solutions.",
        "contactMe": "Contact Me"
    },
    "projects": {
        "title": "My Projects",
        "tabs": {
            "all": "All",
            "featured": "Featured",
            "other": "Others"
        },
        "viewMore": "View {{count}} more technologies",
        "viewLess": "View less",
        "privateProject": "Private project",
        "code": "Code",
        "demo": "Demo (Coming Soon)",
        "items": [
            {
                "id": 1,
                "title": "AI CRM Chatbot - Hytech",
                "description": "Intelligent CRM chatbot platform developed at Hytech with Streamlit. Enables MySQL database searches using natural language through LangChain with custom tools for automatic SQL queries, transforming conversational requests into structured queries. Backend with FastAPI."
            },
            {
                "id": 2,
                "title": "AI-Powered Reporting System - Hytech",
                "description": "Business reporting software developed at Hytech with AI for automated analysis and report generation. Implemented with Streamlit for interactive interfaces and FastAPI for robust backend services."
            },
            {
                "id": 3,
                "title": "Java Web Blog",
                "description": "Web blog developed with Java, JDBC for H2 persistence, JPA and Hibernate for ORM. Frontend with Bootstrap. Includes websockets for chat and Ajax for pagination."
            },
            {
                "id": 4,
                "title": "Mobile Web App",
                "description": "Responsive web application that uses HTML5 with LocalStorage, Geolocator and IndexedDB to capture information without internet connection and synchronize when connectivity is available."
            },
            {
                "id": 5,
                "title": "URL Shortener",
                "description": "URL shortening service with REST and SOAP APIs, JWT security scheme and MongoDB for persistence. Deployed with reverse proxy and custom DNS configuration."
            },
            {
                "id": 6,
                "title": "Telegram Chatbot",
                "description": "Development of a Telegram chatbot using Aiogram (Python) during my work at Click Ping. Integration with external APIs."
            },
            {
                "id": 7,
                "title": "Management System",
                "description": "Business management system with PostgreSQL for data storage. Includes custom reports and administration panel."
            },
            {
                "id": 8,
                "title": "Flutter Pokedex",
                "description": "Mobile application that consumes the Pokemon API to display detailed information about different Pokémon, their stats, evolutions and abilities. Implements advanced search, favorites and comparisons between Pokémon."
            },
            {
                "id": 9,
                "title": "Loan App",
                "description": "Mobile application for personal loan management. Allows registering clients, loans, payments and generates status reports. Includes user authentication and cloud synchronization."
            }
        ]
    },
    "skills": {
        "title": "My Skills",
        "categories": {
            "all": "All",
            "ai": "AI & ML",
            "languages": "Languages",
            "frontend": "Frontend",
            "backend": "Backend",
            "database": "Databases",
            "other": "Others"
        },
        "learning": "I'm always learning new technologies and improving my skills. Currently, I'm deepening my knowledge in advanced AI, LLM fine-tuning, autonomous agent architectures, and enterprise solutions with RAG."
    },
    "experience": {
        "title": "Experience & Education",
        "sections": {
            "work": "Work Experience",
            "education": "Education",
            "achievements": "Achievements"
        },
        "workItems": [
            {
                "id": 1,
                "title": "AI Specialist",
                "company": "Hytech",
                "period": "2024 - Present",
                "description": "Artificial Intelligence Specialist developing innovative enterprise solutions. Development of CRM chatbot platform that enables MySQL database searches using natural language, utilizing LangChain with custom tools for automatic SQL queries. Creation of AI-powered reporting software for automated analysis and report generation. Implementation with Streamlit for interactive interfaces and FastAPI for robust backend services.",
                "technologies": ["Python", "LangChain", "OpenAI", "LLMs", "RAG", "AI Agents", "MySQL", "Streamlit", "FastAPI", "SQL Tools", "Prompt Engineering"]
            },
            {
                "id": 2,
                "title": "Web Developer",
                "company": "Click Ping",
                "period": "2024",
                "description": "Web developer with experience in Django (Python), creating projects such as chatbots for Telegram (Aiogram) and WhatsApp (Meta Flow). Participation in database modeling and Django admin panel configuration.",
                "technologies": ["Python", "Django", "Aiogram", "Meta Flow", "PostgreSQL"]
            }
        ],
        "educationItems": [
            {
                "id": 1,
                "title": "Systems Engineering",
                "institution": "Pontificia Universidad Católica Madre y Maestra (PUCMM)",
                "period": "Graduate - 2024",
                "description": "Degree obtained in Systems Engineering with comprehensive training in software development, databases, networks, information security, and technology project management."
            },
            {
                "id": 2,
                "title": "Secondary Education",
                "institution": "Politécnico Ernesto Disla Nuñez",
                "period": "Graduate",
                "description": "Education in science and technology."
            }
        ],
        "achievementItems": [
            {
                "id": 1,
                "title": "ICPC Latin American Finals 2022",
                "description": "Participant in the International Collegiate Programming Contest (ICPC), qualifying at the regional level and advancing to the 2022 Latin American Finals, competing with countries such as Cuba, Russia, among others."
            }
        ]
    },
    "resume": {
        "title": "My Resume",
        "download": "Download Resume",
        "view": "View Resume in New Tab",
        "openPDF": "Open PDF",
        "updatedRegularly": "This resume is updated regularly with my most recent skills and experiences, but the current one is not updated.",
        "qualifications": "Qualifications Summary",
        "qualificationsList": [
            "Systems Engineer graduated from PUCMM with solid knowledge in web, mobile development, and Artificial Intelligence.",
            "AI Specialist with experience in LLMs, AI Agents, LangChain, RAG, and conversational solution development.",
            "Experience with technologies such as Python, Java, JavaScript, Django, FastAPI, React, Flutter, Streamlit, and modern AI frameworks.",
            "Currently working as AI Specialist at Hytech, developing intelligent chatbot platforms and AI-powered reporting systems using Streamlit and FastAPI.",
            "Development of CRM chatbot platform with natural language searches connected to MySQL using LangChain and custom tools.",
            "Creation of AI-powered business reporting system with Streamlit interfaces and robust FastAPI backend.",
            "Participant in the ICPC 2022 Latin American Finals, demonstrating advanced skills in problem-solving and algorithms.",
            "Ability to model databases and work with different management systems such as PostgreSQL, MongoDB, and MySQL."
        ],
        "moreDetails": "For more details about my education, work experience, and projects, please download or view my complete resume or contact me."
    },
    "credentials": {
        "title": "Degrees and Certifications",
        "subtitle": "Official academic credentials",
        "clickToView": "Click to enlarge",
        "degree": {
            "title": "Computer Science Engineer",
            "institution": "Pontificia Universidad Católica Madre y Maestra (PUCMM)",
            "honor": "Magna Cum Laude",
            "date": "September 2025"
        },
        "certificate": {
            "title": "Official Certification",
            "institution": "Pontificia Universidad Católica Madre y Maestra (PUCMM)",
            "honor": "Magna Cum Laude",
            "date": "September 2025"
        }
    },
    "contact": {
        "title": "Contact Me",
        "info": {
            "title": "Contact Information",
            "phone": "Phone",
            "location": "Location",
            "message": "Do you have a project in mind? Don't hesitate to contact me to discuss how I can help make it a reality."
        },
        "form": {
            "title": "Send Me a Message",
            "name": "Name",
            "email": "Email",
            "subject": "Subject",
            "message": "Message",
            "sending": "Sending...",
            "send": "Send Message",
            "success": "Thank you for your message! I'll get back to you soon.",
            "error": "Error sending the form"
        }
    },
    "footer": {
        "rights": "All rights reserved.",
        "madeWith": "Made with"
    },
    "notFound": {
        "title": "Page Not Found",
        "message": "Sorry, the page you are looking for doesn't exist or has been moved.",
        "redirect": "You will be automatically redirected to the home page...",
        "backToHome": "Back to Home"
    },
    "timeline": {
        "title": "My Journey",
        "viewMore": "View details",
        "viewLess": "View less",
        "items": [
            {
                "id": 1,
                "date": "2025 - Present",
                "title": "AI Specialist at Hytech",
                "description": "Artificial Intelligence Specialist developing innovative enterprise solutions. Development of CRM chatbot platform with natural language searches and AI-powered reporting system.",
                "type": "work",
                "details": [
                    "Development of CRM chatbot platform with MySQL database searches using natural language",
                    "Implementation with LangChain and custom tools for automatic SQL queries",
                    "Creation of AI-powered reporting software for automated analysis and report generation",
                    "Implementation with Streamlit for interactive interfaces and FastAPI for robust backend services"
                ]
            },
            {
                "id": 2,
                "date": "2024 - 2025",
                "title": "Web Developer at Click Ping",
                "description": "Developed web applications using Django (Python), creating projects like chatbots for Telegram (Aiogram) and WhatsApp (Meta Flow). Database modeling and Django admin panel configuration.",
                "type": "work",
                "details": [
                    "Created RESTful APIs for internal and external services",
                    "Implemented authentication and authorization using JWT",
                    "Worked with PostgreSQL for database management",
                    "Collaborated with UX/UI designers for frontend implementation"
                ]
            },
            {
                "id": 3,
                "date": "2023",
                "title": "International Collegiate Programming Contest (ICPC)",
                "description": "Qualified at the regional level, advancing to the Latin American Final 2022, competing with countries such as Cuba, Russia, among others.",
                "type": "achievement",
                "details": [
                    "Solved complex algorithmic problems under time pressure",
                    "Collaborated with teammates to devise efficient solutions",
                    "Practiced advanced data structures and algorithms",
                    "Developed problem-solving skills in competitive environments"
                ]
            },
            {
                "id": 4,
                "date": "2022 - Present",
                "title": "Full Stack Development Projects",
                "description": "Developed various web applications, including a blog platform, URL shortener, and mobile web applications.",
                "type": "project",
                "details": [
                    "Created a blog web with Java, JDBC, JPA, and Hibernate",
                    "Developed a URL shortener service with REST and SOAP APIs",
                    "Built mobile-responsive web applications using HTML5 features like LocalStorage and IndexedDB",
                    "Implemented secure authentication and data persistence"
                ]
            },
            {
                "id": 5,
                "date": "2020 - 2024",
                "title": "Systems Engineering Graduate - PUCMM",
                "description": "Graduated in Systems Engineering from Pontificia Universidad Católica Madre y Maestra, with training in software development, databases, networks, and technology project management.",
                "type": "education",
                "details": [
                    "Coursework in algorithms, data structures, and design patterns",
                    "Database management and systems architecture",
                    "Software engineering practices and methodologies",
                    "Network infrastructure and security protocols"
                ]
            },
            {
                "id": 6,
                "date": "2019",
                "title": "Secondary Education at Politécnico Ernesto Disla Nuñez",
                "description": "Completed secondary education with a focus on science and technology.",
                "type": "education",
                "details": [
                    "Graduated with honors",
                    "Participated in programming and mathematics competitions",
                    "Developed foundational understanding of computing principles",
                    "Led student technology projects"
                ]
            }
        ]
    },
    "hobbies": {
    "title": "My Interests and Hobbies",
    "subtitle": "Beyond programming, these are some of the activities I enjoy in my free time.",
    "backToPortfolio": "Back to portfolio",
    "footer": "Do we share any interests? Tell me about it in the contact section!",
    "items": [
        {
            "name": "Cycling",
            "description": "I enjoy exploring new routes by bike on weekends, discovering natural and urban landscapes. It's my favorite form of exercise and connection with nature.",
            "details": [
                "Favorite routes in Santiago",
                "Participation in local cycling events",
                "Bicycle maintenance as an additional hobby"
            ]
        },
        {
            "name": "Programming",
            "description": "Beyond the professional aspect, I enjoy programming personal projects and participating in hackathons. I like to experiment with new technologies and languages.",
            "details": [
                "Participation in programming competitions",
                "Contributions to open source projects",
                "Development of small applications for personal use"
            ]
        },
        {
            "name": "Listening to Music",
            "description": "Music is my constant companion. I enjoy exploring different genres and discovering new artists. I have a collection of playlists for different moods and activities.",
            "details": [
                "Favorite genres: alternative rock, jazz, and electronic music",
                "Digital collector of classic albums",
                "Attendance at local concerts when possible"
            ]
        },
        {
            "name": "Studying",
            "description": "I am passionate about continuous learning, not only in technology but in various fields of knowledge. I regularly dedicate time to online courses, technical books, and scientific articles.",
            "details": [
                "Completed courses on platforms like Coursera and edX",
                "Regular reading of technical publications",
                "Participation in study groups"
            ]
        },
        {
            "name": "Video Games",
            "description": "Video games are my favorite form of relaxation. I especially enjoy strategy games, RPGs, and independent titles with innovative narratives.",
            "details": [
                "Favorite games: Civilization series, The Witcher, Hollow Knight",
                "Interest in indie game development",
                "Occasional participation in game jams"
            ]
        },
        {
            "name": "Hiking",
            "description": "Discovering new routes and connecting with nature is one of my favorite activities. I like to document my hikes and explore new trails in the Dominican Republic.",
            "details": [
                "Favorite routes in the Northern Mountain Range",
                "Landscape photography as a complementary hobby",
                "Route planning using GPS technology"
            ]
        },
        {
            "name": "Movies",
            "description": "I am a movie enthusiast, especially of science fiction, technological documentaries, and independent films. I like to analyze narratives and cinematographic techniques.",
            "details": [
                "Favorite directors: Christopher Nolan, Denis Villeneuve",
                "Regular attendance at local film festivals",
                "Interest in the intersection between technology and visual narratives"
            ]
        }
    ]
}
};

const resources = {
    es: {
        translation: translationES
    },
    en: {
        translation: translationEN
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'es',
        debug: true,

        interpolation: {
            escapeValue: false,
        },

        detection: {
            order: ['localStorage', 'navigator'],
            lookupLocalStorage: 'preferredLanguage',
            caches: ['localStorage'],
        }
    });

export default i18n;